
    import './styles.scoped.css';
    export default {
  "root": "_root_12hcx_3",
  "content": "_content_12hcx_25",
  "content-no-paddings": "_content-no-paddings_12hcx_25",
  "content-has-header": "_content-has-header_12hcx_28",
  "header": "_header_12hcx_32",
  "header-no-paddings": "_header-no-paddings_12hcx_36",
  "header-sticky": "_header-sticky_12hcx_39",
  "header-stuck": "_header-stuck_12hcx_44",
  "footer": "_footer_12hcx_48"
};
  